import {UserSelectField} from './UserSelectField';

/**
 * Thin adapter so <UserSelectField> can be used as a direct child of an antd
 * <Form.Item>. antd injects `value`/`onChange`; UserSelectField expects
 * `users`/`setUsers`. The stored form value is the array of option keys in the
 * "firstName;lastName;id;email" shape — extract ids at submit time with
 * `extractUserIds` from the announcement actions helper.
 */
export const UserSelectFormField = ({
  value,
  onChange,
  defaultUsers,
  mode,
  placeholder,
  admin,
  skip,
}) => (
  <UserSelectField
    users={value}
    setUsers={onChange}
    defaultUsers={defaultUsers}
    mode={mode}
    placeholder={placeholder}
    admin={admin}
    skip={skip}
  />
);
